import { OptionProps } from 'react-select'

import { IJudgeOption } from '../../../../models/event-fees/event-fees.interface'

export const FenceHeightOption = (props: OptionProps<IJudgeOption, false>) => {
  const { data, innerRef, innerProps, isFocused, isSelected } = props

  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: '10px',
        backgroundColor: isFocused ? '#eee' : 'white',
        borderTop: data.isBorderTop ? '1px solid #D3DAEE' : 'none',
        fontWeight: isSelected ? 'bold' : 'normal',
      }}
    >
      {data.label}
    </div>
  )
}
